import React from 'react';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
// icon
import IconCheck from 'material-ui/svg-icons/navigation/check';
import IconUpload from 'material-ui/svg-icons/action/cached';
import IconCreate from 'material-ui/svg-icons/content/create';
// momentjs
import moment from 'moment';
// config
import { staticUrl } from '../../lib/config';
// style
import styleGallery from './media-gallery-style';
import './media-gallery.css';
import { colors } from '../../lib/styles';
import modernEnvironment from '../../lib/RelayUtils';
import * as MediaFileEditMutation from '../../mutations/MediaFileEditMutation';

import setCategory from './setCategory';

require('moment/locale/ru');

type Props = {
    viewType: ?string,
    insertItem: ?Function,
    insertItemIcon: ?boolean,
    onClick: ?Function,
    selected: ?boolean,
    mediaFile: {
        alt: ?string,
        description: ?string,
        filename: string,
        id: string,
        preview: ?string,
        status: ?string,
        title: ?string,
        type: string,
        updatedAt: string,
    }
}

class MediaGalleryListItem extends React.Component<Props> {
    constructor(props) {
        super(props);
        this.state = {
            viewType: this.props.viewType,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.viewType !== this.state.viewType) {
            this.setState({ viewType: nextProps.viewType });
        }
    }

    parseData = (data) => {
        const status = {
            created: 'Готово!',
            upload: 'Процессинг!',
        };
        return {
            id: data.id || '',
            alt: data.alt || ' ',
            title: data.title || ' ',
            authors: data.authors ? data.authors[0] : '',
            description: data.description || '',
            filename: data.filename || '',
            rating: data.rating || '',
            type: data.type || '',
            show: data.show || '',
            time: data.long || '',
            date: data.updatedAt || '',
            statusPrev: data.status || 'created',
            status: status[data.status] || 'Готово!',
            preview: data.preview || '',
            topics: data.topics || [],
            slug: data.slug || '',
            seoTitle: data.seoTitle || '',
            seoDescription: data.seoDescription || '',
            seoKeywords: data.seoKeywords || '',
        };
    };

    updateItemShowField = (item) => {
        if (item.show.length || item.type !== 'video') {
            return;
        }
        const filter = setCategory();
        if (!filter) {
            return;
        }

        const params = {
            id: item.id,
            title: item.title.trim(),
            description: item.description,
            alt: item.alt,
            filename: item.filename,
            rating: item.rating,
            authors: item.authors,
            type: item.type,
            status: 'created',
            state: 'available',
            preview: item.preview,
            topics: item.topics.map(topic => topic.id),
            show: filter,
            slug: item.slug,
            seoTitle: item.seoTitle,
            seoDescription: item.seoDescription,
            seoKeywords: item.seoKeywords,
        };
        MediaFileEditMutation.commit(modernEnvironment, params, (result) => {});
    };

    renderTableRow = item => (
        <TableRow
            className="table--row"
            style={{ border: 'none' }}
            onClick={() => {
                this.props.onClick(item);
            }}
        >
            <TableRowColumn style={{ ...styleGallery.columnTitle, ...styleGallery.columnCell }}>
                <div className="table--cell-inner">
                    {item.title}
                </div>
            </TableRowColumn>
            <TableRowColumn style={{ ...styleGallery.columnDate, ...styleGallery.columnCell }}>
                <div className="table--cell-inner">
                    {moment(item.date).format('HH:mm')}
                    <br />
                    {moment(item.date).format('DD.MM.YYYY')}
                </div>
            </TableRowColumn>
            <TableRowColumn style={{ ...styleGallery.columnLong, ...styleGallery.columnCell }}>
                <div className="table--cell-inner">
                    {item.time}
                </div>
            </TableRowColumn>
            <TableRowColumn style={{ ...styleGallery.columnStatus, ...styleGallery.columnCell }}>
                <div className="table--cell-inner">
                    {item.status}
                </div>
            </TableRowColumn>
        </TableRow>
    );

    renderGrid = (item) => {
        const title = item.title.trim() || item.show.title;
        const fileStatus = item.statusPrev === 'created' || item.statusPrev === 'processed';
        let previewClass = `grid-item--img ${this.props.selected && 'grid-item--img_active'}`;
        let previewUrl = item.type === 'image' ? `${staticUrl}/${item.filename}` : `${staticUrl}/${item.preview}`;
        if (item.type === 'video' && !item.preview) {
            previewClass = `${previewClass} is-empty`;
            previewUrl = '/preview.png';
        }

        const showForVideo = item.type === 'video';
        return (
            <div className="grid-item">
                <div className={previewClass}>
                    <div className="grid-item--edit">
                        <div className="grid-item--edit-top">
                            {this.props.insertItemIcon &&
                            <IconButton
                                style={{
                                    padding: 0,
                                    width: 24,
                                    height: 24,
                                    marginRight: 10,
                                }}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.onClick(item);
                                }}
                            >
                                <IconCreate
                                    color="#50e3c2"
                                    hoverColor={colors.linkHover}
                                />
                            </IconButton>
                            }
                        </div>
                        {this.props.insertItemIcon &&
                        <div
                            className="grid-item--edit-middle grid-item--edit-middle_insert"
                            onClick={() => {
                                this.updateItemShowField(item);
                                this.props.insertItem(item);
                            }}
                        />
                        }
                        {!this.props.insertItemIcon &&
                        <div
                            className="grid-item--edit-middle grid-item--edit-middle_edit"
                            onClick={(event) => {
                                event.preventDefault();
                                this.props.onClick(item);
                            }}
                        />
                        }
                    </div>
                    <img
                        src={previewUrl}
                        alt={item.alt}
                        className="grid-item--img-element js-item-img"
                        style={{
                            width: this.state.width,
                            height: this.state.height,
                        }}
                    />
                </div>
                <div className="grid-item--description">
                    <div className="grid-item--info">
                        <div className="grid-item--title js-item-title">{title}</div>
                        {showForVideo &&
                        <div className="grid-item--date js-item-date">
                            {moment(item.date).format('DD MMMM YYYY')} года
                        </div>
                        }
                    </div>
                    {showForVideo &&
                    <div className="grid-item--status">
                        {fileStatus && <IconCheck color="#46bc98" />}
                        {!fileStatus &&
                        <div className="icon-rotate">
                            <IconUpload color="#ff8201" />
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
        );
    };

    render() {
        const item = this.parseData(this.props.mediaFile);
        const { viewType } = this.state;
        if (viewType === 'list') {
            return this.renderTableRow(item);
        }
        return this.renderGrid(item);
    }
}

export default MediaGalleryListItem;



// WEBPACK FOOTER //
// src/components/media/MediaGalleryListItem.js